import { render, staticRenderFns } from "./ServiceJoinStep2Contentsogvtn.vue?vue&type=template&id=18096d9a"
import script from "./ServiceJoinStep2Contentsogvtn.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep2Contentsogvtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18096d9a')) {
      api.createRecord('18096d9a', component.options)
    } else {
      api.reload('18096d9a', component.options)
    }
    module.hot.accept("./ServiceJoinStep2Contentsogvtn.vue?vue&type=template&id=18096d9a", function () {
      api.rerender('18096d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep2Contentsogvtn.vue"
export default component.exports